import React from "react";
import { Play } from "../../Common/SI";
import { PlayBlock } from "../PlayBlock";

export interface DurationFrequencyChartProps {
	plays: Play[]
}

export const DurationFrequencyChart = React.memo(function (props: DurationFrequencyChartProps): JSX.Element {

	const bucketSize = 5 // minutes

	const playsByMinutes: Map<number, Play[]> = new Map()
	let minMinutes: number | undefined
	let maxMinutes: number | undefined
	let totalMinutes: number = 0
	let playsCount: number = 0

	for (let i = props.plays.length - 1; i >= 0; i--) {
		const play = props.plays[i]
		if (play.durationMins === null) {
			continue
		}

		const rounded = Math.round(play.durationMins / bucketSize) * bucketSize

		let plays = playsByMinutes.get(rounded)
		if (!plays) {
			plays = []
			playsByMinutes.set(rounded, plays)
		}

		plays.push(play)

		totalMinutes += play.durationMins
		playsCount++

		if (minMinutes === undefined || rounded < minMinutes) {
			minMinutes = rounded
		}
		if (maxMinutes === undefined || rounded > maxMinutes) {
			maxMinutes = rounded
		}
	}

	if (minMinutes !== undefined && maxMinutes !== undefined) {
		for (let minutes = minMinutes; minutes <= maxMinutes; minutes += bucketSize) {
			if (!playsByMinutes.has(minutes)) {
				playsByMinutes.set(minutes, [])
			}
		}
	}

	const durations = Array.from(playsByMinutes.keys())
	durations.sort((a, b) => a - b)

	return (
		<div className="chart duration-frequency">
			<div className="histogram">
				{
					durations.map(minutes => (
						<div className="labeled-column" key={minutes}>
							<div className="column-label sideways">{getDuration(minutes)}</div>
							{
								playsByMinutes.get(minutes)!.map(play => (
									<PlayBlock key={play.number} play={play} />
								))
							}
						</div>
					))
				}
			</div>
			<div className="histogram-x-axis-label">
				Duration {
					!!playsCount && <React.Fragment>
						(mean {getDuration(Math.round(totalMinutes / playsCount))})
					</React.Fragment>
				}
			</div>
		</div>
	)
})

function getDuration(minutes: number): string {
	return `${Math.floor(minutes / 60)}:${('0' + (minutes % 60)).slice(-2)}`
}
